module.exports = __webpack_public_path__ + "img/lc_map04.c6e4f8fb.jpg";